const PersianNumberFormat = (number, withCommas = false, toAlpha = false, card = false) => {
  // Formatting helpers are consumed directly by text fields and JSX. Keep the
  // return type stable even when an optional API field is null or undefined.
  if (number === null || number === undefined || number === '') {
    return '';
  }

  if (toAlpha) {
    return numberToPersianWords(number)
  }

  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  const englishDigits = '0123456789';
  const separator = withCommas ? ',' : '';

  const pattern = /^(\d{4})(\d{4})(\d{4})(\d{4})$/;


  const formattedNumber = withCommas
    ? String(number).replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    : card ? String(number).replace(pattern, '$1-$2-$3-$4') : number

  const persianFormattedNumber = [...String(formattedNumber)]
    .map((digit) => {
      return persianDigits[englishDigits.indexOf(digit)] || digit
    })
    .join('');

  return persianFormattedNumber;
};

function numberToPersianWords(number) {
  const persianDigits = ['صفر', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
  const persianTens = ['ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
  const persianHundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];

  if (number === 0) return persianDigits[0];
  if (number == 11) return "یازده";
  if (number == 12) return "دوازده";

  let words = '';
  let threeDigitsGroup = '';

  for (let i = 0; number > 0; i++) {
    let threeDigits = number % 1000;
    number = Math.floor(number / 1000);

    if (threeDigits !== 0) {
      let digits = threeDigits % 10;
      let tens = Math.floor((threeDigits % 100) / 10);
      let hundreds = Math.floor(threeDigits / 100);

      let threeDigitsWord = '';

      if (hundreds > 0)
        threeDigitsWord += persianHundreds[hundreds] + ' و ';

      if (tens === 1) {
        threeDigitsWord += persianTens[digits];
      } else if (tens !== 0 || digits !== 0) {
        if (digits !== 0)
          threeDigitsWord += persianDigits[digits];
        if (tens !== 0)
          threeDigitsWord += (digits !== 0 ? ' و ' : '') + persianTens[tens];
      }

      if (i > 0)
        threeDigitsWord += ' ' + ['هزار', 'میلیون', 'میلیارد'][i];

      threeDigitsGroup = threeDigitsWord + (words === '' ? '' : ' و ') + words;
    }

    words = threeDigitsGroup;
  }

  return words;
}

export default PersianNumberFormat;
